import { GOOGLE_FIREBASE_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { GoogleFirebaseConfigModel } from "./google-setting.models";

export const getFirebaseConfig = async () => {
  return await apiClient.getHttp<GoogleFirebaseConfigModel>(`${GOOGLE_FIREBASE_API}`);
};
export const updateFirebaseConfig = async (model: GoogleFirebaseConfigModel) => {
  const response = await apiClient.postHttp(`${GOOGLE_FIREBASE_API}`, model);
  return response;
};
